import videojs from "@/vendor/videojs/video.es.js";
import VirtualDirector from "@/vendor/vd.js";

const Plugin = videojs.getPlugin("plugin");

class HiShared extends Plugin {
  constructor(player, options) {
    super(player, options);
    this.player = player;

    player.hiliteSports = {};
    player.fps = 30;

    player.hiliteSports.videoElWrapper = document.createElement('div');
    player.hiliteSports.videoElWrapper.classList.add("video-wrapper");
    player.hiliteSports.videoEl = player.el().getElementsByTagName("video")[0];

    player.hiliteSports.videoEl.parentNode.insertBefore(player.hiliteSports.videoElWrapper, player.hiliteSports.videoEl);
    player.hiliteSports.videoElWrapper.appendChild(player.hiliteSports.videoEl);

    this.on(player, "updateVd", this.createVd);

    this.createVd(null, options)
  }
  dispose() {
    super.dispose();
  }
  update(options) {
    this.createVd(options)
  }
  createVd(e, options) {
    this.player.hiliteSports.vd = new VirtualDirector(this.player.hiliteSports.videoElWrapper, this.player.hiliteSports.videoEl, {
      scene_w: 5572,
      scene_h: 2040,
      center_top: 522,
      center_bottom: 1640,
      top_inset: 290,
      fps: 30,
      min_zoom: options.minZoom,
      max_zoom: options.maxZoom
    }, options.vd || [0, 0, 0, 0, 100]);
  }
}

videojs.registerPlugin("HiShared", HiShared);
